module.exports = __webpack_public_path__ + "static/media/main3_zh.f7b76c65.png";